<template>

    <!-- <v-app class="pa-0 ma-0" id="mainhomecontainer"> -->
        <v-container id="mainhomecontainer" style="" fluid class="clear-footer pa-0 ma-0">
        <div class="pa-0 pl-1" style="font-size:10px;">EditBusinessDrinkItem</div>
        <v-divider></v-divider>
        <v-row no-gutters align="center" justify="center">
            <v-col cols="12" md="12" class="pa-0 ma-0" style="justify-content:space-around">
                <div class="section-label pb-0 ma-0 pl-1">{{$t('zz_edit_drink_item')}}</div>
                <div class="english-label-black pa-0 ma-0 pl-1">EDIT DRINK ITEM</div>
            </v-col>
        </v-row>
        <!-- <v-container elevation="0" class=""> -->
            <v-overlay v-model="overlay" color= "#FE5800" >
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-divider></v-divider>
            <!-- <v-container style="margin-bottom:30px;"> -->

            <v-form v-model="valid" enctype="multipart/form-data" id="editdrinkitem" autocomplete="off" class="">
                <v-container elevation="0" class="relative split-container ma-0 pa-0">
                    <v-overlay v-model="overlay"
                        color= "#FE5800" >
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>

<!--PREVIEW  -->
                        <v-container elevation="0" style="position:sticky;top:50px" class="preview-screen pb-12 mb-12">
                            <div v-if="showonmenu==0 && !separator" flex-wrap class="coursehidden"><span v-html="$t('zz_hidden_item_notice_item')"></span></div>
                            <div v-if="showonmenu==0 && separator" flex-wrap class="separatorhidden"><span v-html="$t('zz_hidden_item_notice_item')"></span></div>

                            <v-img style="position:relative" class="true-center" :src="iphone"></v-img>
<!-- DRINK CARD PREVIEW                    -->
                            <v-container class="preview-cards-container">

<!-- DRINK ITEM CARD PREVIEW    -->
                                <v-card v-if="!separator" elevation="6" class="new-drink-tiem-preview-card pa-0">
                                    <v-row no-gutters style="align-items:flex-end" class="pa-0 ma-0">
                                            <v-col cols="4" md="4" style="text-align-last: center;" class="ma-0 pa-0">
                                                <img
                                                    class="centeredimg ma-0 pa-0 my-1"
                                                    contain
                                                    height="125px"
                                                    max-width="100%"
                                                    :src="image">
                                            </v-col>
                                            <v-col cols="8" md="8" class="pa-0 ma-0 pa-3 drink-card-text-area">
                                                    <p class="pa-0 ma-0 drink-name">{{data.name}}</p>
                                                    <p class="pa-0 ma-0 drink-subname-list">{{data.subname}}</p>
                                                    <p class="pa-0 ma-0 drink-strapline-list">{{data.brand}}</p>
                                                <v-row cols="12" class="pa-0 ma-0 mt-2">
                                                    <span class="drink-description-list-view" v-html="data.description"></span>
                                                    <!-- <span class="drink-description-list-view">{{description}}</span> -->
                                                </v-row>
                                                <v-col cols="12" md="12" sm="12" class="ma-0 pa-0" v-for="(item, index) in drinkMeasureitem" :key="index">

                                                    <v-row no-gutters v-if="item.id" style="line-height: 10px !important" class="">
                                                        <v-col cols="12" class="pa-0 ma-0">
                                                            <v-row no-gutters style="align-items:baseline" class="pa-0 ma-0">
                                                                <v-col cols="7" md="7" class="drink-price-measure-list mr-0">
                                                                    {{ (item.drinkmeasure) }}<span class="drink-price-unit-list mr-0 text-right"> {{item.qty}}{{ (item.uname) }}</span>
                                                                </v-col>
                                                                <v-col cols="3" md="3" class="drink-price-list mr-0">
                                                                    {{item.price}}
                                                                </v-col>
                                                                <v-col cols="2" md="2" class="drink-price-icon-list">
                                                                    <v-row no-gutters  class="ma-0">
                                                                        <v-col cols="12" class="drink-favorite">
                                                                            <v-icon size="12" class="pt-1" color="#fe5800">mdi-heart</v-icon>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <!-- <v-col cols="12" md="12" sm="12" class="ma-0 pa-0">
                                                    <v-row style="line-height: 12px !important" class="ml-0 mr-0 mb-2 drink-price-section">
                                                        <v-col cols="12" class="pt-0 pb-0">
                                                            <v-row style="align-items: baseline">
                                                                <v-col cols="7" md="7" class="drink-price-measure-list mr-0">
                                                                    Glass<span class="drink-price-unit-list mr-0 text-right"> 75ml</span>
                                                                </v-col>
                                                                <v-col cols="3" md="3" class="drink-price-list mr-0">
                                                                    22.99
                                                                </v-col>
                                                                <v-col cols="2" md="2" class="drink-price-icon-list">
                                                                    <v-row class="ma-0">
                                                                        <v-col cols="12" class="drink-favorite">
                                                                            <v-icon size="12" class="pt-1" color="#fe5800">mdi-heart</v-icon>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-col> -->
                                            </v-col>
                                    </v-row>

                                </v-card>
<!-- SEPARATOR PREVIEW                              -->
                                <v-card v-if="separator" elevation="6" class="edit-drink-card">
                                    <v-col cols="12" class="separator pa-0 ma-0 py-1" style="color:primary">
                                        <p class="separator-name text-center">{{data.name}}</p>
                                        <p class="separator-subname text-center">{{data.subname}}</p>
                                    </v-col>
                                </v-card>
<!-- 2nd Drink Card PLACEHOLDER DRINK ITEM DO NOT EDIT                             -->
                            <v-card elevation="6" class="edit-drink-card2 pa-0">
                                <v-row no-gutters style="align-items:flex-end" class="pa-0 ma-0">
                                        <v-col cols="4" md="4" class="ma-0 pa-0">
                                            <img
                                                class=" ma-0 pa-0 my-1"
                                                contain
                                                max-height="75px"
                                                width="100%"
                                                :src="placeholder">
                                        </v-col>
                                        <v-col cols="8" md="8" class="pa-0 ma-0 pt-3 px-3 drink-card-text-area">
                                            <v-row cols="12" class="pa-0 ma-0 drink-name">JOSÉ LUIS FERRER 2019</v-row>
                                            <v-row cols="12" class="pa-0 ma-0 drink-subname-list">ROSE</v-row>
                                            <v-row cols="12" class="pa-0 ma-0 drink-strapline-list">Mallorcian Wine</v-row>
                                            <v-row cols="12" class="pa-0 ma-0 mt-2 drink-description-list-view-ph">A local wine grown in the stunning Tranmutana Mountians on the West Coast of Mallorca</v-row>
                                            <v-col cols="12" md="12" sm="12" class="ma-0 pa-0">
                                                <v-row style="line-height: 12px !important" class="ml-0 mr-0 mb-2 drink-price-section">
                                                    <v-col cols="12" class="pt-0 pb-0">
                                                        <v-row style="align-items: baseline">
                                                            <v-col cols="7" md="7" class="drink-price-measure-list mr-0">
                                                                Glass<span class="drink-price-unit-list mr-0 text-right"> 75ml</span>
                                                            </v-col>
                                                            <v-col cols="3" md="3" class="drink-price-list mr-0">
                                                                12.99
                                                            </v-col>
                                                            <v-col cols="2" md="2" class="drink-price-icon-list">
                                                                <v-row class="ma-0">
                                                                    <v-col cols="12" class="drink-favorite">
                                                                        <v-icon size="12" class="pt-1" color="#fe5800">mdi-heart</v-icon>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-col>
                                </v-row>

                            </v-card>
                            </v-container>
                        </v-container>
<!--END PREVIEW  -->

<!-- EDIT CONTAINER CARD  -->
                        <v-container elevation="12" style="position:relative;justify-conent:center" class="card-in-cards-container-stretch pa-3 ma-0 pb-12 mb-12 bgpanel">
                            <v-row class="edit-drink-card">
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col class="pa-3 card-title card-preview">{{$t('zz_show_on_juZZap')}}
                                                <div class="english-label-black pa-0 ma-0">ED1 SHOW ON juZZap</div>
                                            </v-col>
                                            <v-col cols="3" md="3">
                                                <v-switch label="" v-model="showonmenu" color="success"></v-switch>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters style="justify-content: space-between;align-items:flex-end" class="pa-3">
                                                <div v-if="showonmenu==0" flex-wrap class="hidden-notice2"><span v-html="$t('zz_hidden_item_notice_item')"></span></div>
                                                <div v-if="showonmenu==0" class="">
                                                    <v-dialog
                                                    v-model="dialog"
                                                    width="800"
                                                    v-bind="attrs"
                                                    v-on="on">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn
                                                                x-small
                                                                elevation="2"
                                                                color="#FE5800"
                                                                fab
                                                                v-bind="attrs"
                                                                v-on="on">
                                                                <v-icon color="white">mdi-eye-off-outline</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <v-card>
                                                        <v-card-title class="section-spread text-h1 zzorganebg">
                                                            <h1 class="font-weight-bold display-1 text--pr"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-eye-off-outline</v-icon>{{$t('zz_hidden_item_notice')}}</h1>
                                                        </v-card-title>
                                                        <p class="pt-5 px-4">
                                                            <span v-html="$t('zz_hidden_item_explained')">
                                                            </span>
                                                        </p><br>
                                                        <v-divider></v-divider>
                                                        <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br>
                                                        </v-card>
                                                    </v-dialog>
                                                </div>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            <v-container class="pa-0 ma-0" v-if="!separator">

<!-- BEVERAGE SEARCH -->
                                <!-- <v-row class="px-3 spaced-apart">
                                    <v-col cols="6">
                                        <strong >{{$t('zz_beverage_search')}}</strong>
                                    </v-col>
                                </v-row> -->

                                <!-- <v-card elevation="24"  v-if="linkhref" style="" class="edit-drink-card pa-3 my-3"> -->
                                <v-card v-if="linkhref" elevation="24" style="" class="edit-drink-card pa-3 my-3">
                                <v-row>
                                        <v-col cols="6" md="6">
                                            <v-btn :href="linkhref" target="_blank" class="d-none d-md-flex px-3 px-2 ma-1 footer-buttons" color="#FE5800" elevation="2" x-large >{{$t('zz_order_item')}}</v-btn>
                                            <!-- <v-btn :href="linkhref" target="_blank" class="footer-buttons" color="#FE5800">{{$t('zz_reorder_item')}}</v-btn> -->
                                        </v-col>
                                    </v-row>
                                </v-card>


                            </v-container>
<!-- ADD IMAGE/CROPPER -->
                            <v-container v-if="!separator" style="max-width:100%" class="pa-0 ma-0">
                                <v-row class="">
                                    <v-col cols="12">
                                        <div class="section-label pb-0 ma-0">{{$t('zz_add_photo')}}</div>
                                        <div class="english-label-black pa-0 ma-0">ED2 ADD PHOTO  </div>
                                    </v-col>
                                </v-row>
                                <v-card elevation="24" style="" class="edit-drink-card pa-3 my-3">
                                    <v-icon style="position:absloute;justify-content:flex-end;top:12px;right:12px;z-index:10" color="red" icon dark  class="close" @click="deleltemainImage()">mdi-close-circle</v-icon>
                                    <template>
                                            <v-container class="ma-0 pa-0">
                                                <v-col class="pa-0 ma-0">
                                                    <v-row v-if="mainimguploading" style="width:fit-content">
                                                        <v-col cols="12" class="text-center">
                                                        <v-progress-circular
                                                            indeterminate
                                                            color="primary"
                                                            ></v-progress-circular>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row v-show="uploadedimage==null || uploadedimage=='null' || uploadedimage==''" no-gutters style="justify-content:center" class="ma-0 pa-0">
                                                    <img
                                                        class="drink-image ma-0 pa-0 my-1"
                                                        contain
                                                        :src="image">
                                                    <!-- <v-btn class="edit-food-photo-icon" style="position:absolute; top:47%;color:#fff" icon @click="$refs.file.click()">
                                                        <v-icon style="font-size:50px;color:#FE5800" class="pa-10 image-icon">mdi-image-edit</v-icon>
                                                    </v-btn> -->
                                                        <input
                                                        type="file"
                                                        ref="file"
                                                        @change="uploadImage($event)"
                                                        accept="image/*"
                                                        class="d-none"
                                                        id="itemimage"
                                                        />
                                                    <!-- </v-img> -->
                                                    </v-row>
                                                    <v-container v-show="uploadedimage!=null && uploadedimage!='null'" class="relative cropper">
                                                        <!-- <div>
                                                            <v-btn
                                                                class="image-icon bgb"
                                                                style="position:absolute;top:40%;right:47%;color:white;z-index:100"
                                                                icon
                                                                @click="$refs.file.click()">
                                                            <v-icon
                                                                style="font-size:50px;color:#FE5800"
                                                                class="pa-10 image-icon">
                                                            mdi-image-edit
                                                            </v-icon>
                                                        </v-btn>
                                                        </div> -->
                                                        <Cropper  :src="uploadedimage" @change="onChange" :stencilProps="{aspectRatio: 3/4}"/>
                                                    </v-container>
                                                </v-col>
                                            </v-container>
                                    </template>
                                    <v-btn class="pa-3 footer-buttons" color="#FE5800" elevation="2" small @click="$refs.file.click()">{{$t('zz_edit_photo')}}</v-btn>
                                </v-card>
                            </v-container>
<!-- DRINK DETAILS ADMIN-->
                            <v-row class="px-3 spaced-apart">
                                <v-col v-if="!separator" cols="6">
                                    <div class="section-label pb-0 ma-0">{{$t('zz_drink_details')}}</div>
                                        <div class="english-label-black pa-0 ma-0">ED3 DRINK DETAILS  </div>
                                </v-col>
                                <v-col v-if="separator" cols="6">

                                    <div class="section-label pb-0 ma-0">{{$t('zz_separator')}}</div>
                                        <div class="english-label-black pa-0 ma-0">ED3.1 SEPARATOR  </div>
                                </v-col>
                            </v-row>
<!-- Name Subname Strapline & Description                             -->
                            <v-card elevation="24" style="" class="edit-drink-card pa-3 my-3">
                                <!-- <v-row no-gutters> -->
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <img :src="lphoto" height="20px">
                                            <span class="lang-short-code"> - {{lcode}}</span>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters cols="12" md="12" class="mr-1">

                                        <v-text-field
                                        class="text-center"
                                            outlined
                                            v-model="data.name"
                                            name="name"
                                            :label="$t('zz_title')"
                                            required
                                            v-validate="'required|max:100'"
                                            :error-messages="errors.collect('name')"
                                            data-vv-name="name">
                                        </v-text-field>
                                    </v-row>
                                    <v-row no-gutters  cols="12" md="12" class="mr-1">
                                        <v-text-field
                                        outlined
                                        v-model="data.subtitle"
                                        name="subtitle"
                                        :label="$t('zz_sub_title')"
                                        required
                                        v-validate="'required|max:100'"
                                        :error-messages="errors.collect('subtitle')"
                                        data-vv-name="subtitle">
                                        </v-text-field>
                                    </v-row>
                                    <v-row v-if="!separator" no-gutters cols="12" md="12" class="">
                                        <v-text-field
                                            outlined
                                        v-model="data.brand"
                                        name="brand"
                                        :label="$t('zz_state_province_region')"
                                        ></v-text-field>
                                    </v-row>
                                <!-- </v-row> -->
                                <v-row v-if="!separator">
                                        <v-row no-gutters cols="12" md="12" class="px-3">
                                            <editor
                                            style="width:100%"
                                            api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                            initialValue=""
                                            v-model="data.description"
                                            :init="editorConfigDescription"
                                            class="drink-description-list-view"
                                            ></editor>
                                        </v-row>
                                    </v-row>
                            </v-card>
<!-- DRINK PRICE & MEASURES -->

                            <v-container v-if="!separator" class="pa-0 ma-0">
                                <v-divider></v-divider>
                                <v-row class="px-3">
                                    <v-col cols="12">
                                        <div class="section-label pb-0 ma-0">{{$t('zz_drink_measures_price')}}</div>
                                        <div class="english-label-black pa-0 ma-0">ED4 MEASURES & PRICES  </div>
                                    </v-col>
                                </v-row>
                                <v-card elevation="24" v-for="(item, index) in drinkMeasureitem" :key="index" class="relative edit-drink-card pa-3 my-3">
                                    <v-row no-gutters class="pa-0 ma-0">
                                        <v-col cols="" class="mx-1">
                                            <v-autocomplete
                                                :label="$t('zz_serving')"
                                                v-model="item.id"
                                                :name="'drinkMeasure_id['+index+']'"
                                                item-text="name"
                                                item-value="id"
                                                :items="drinkMeasures"
                                                @change="fetchMeasureName(index)"
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="" class="mx-1">
                                            <v-text-field
                                                style="text-align-last:right"
                                                v-model="item.qty"
                                                :name="'qty['+index+']'"
                                                :label="$t('zz_quantity')"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="" class="mx-1">
                                            <v-autocomplete
                                                style="text-align-last:right"
                                                :label="$t('zz_ml')"
                                                v-model="item.unit_id"
                                                :name="'unit_id['+index+']'"
                                                item-text="name"
                                                item-value="id"
                                                :items="units"
                                                @change="setUnitName(index)">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="" class="mx-1">
                                            <v-text-field
                                                style="text-align-last:right"
                                                v-model="item.price"
                                                :name="'price['+index+']'"
                                                :label="$t('zz_price')"
                                                :placeholder="$t('zz_decimalplace')"
                                                @keypress="isNumber($event)"
                                                >
                                                <!-- <v-icon slot="prepend" v-text="business.currency.icon"></v-icon> -->
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col class="pa-0 ma-0 pb-3"  style="width:25px;z-index:2;position:absolute;right:-10px;top:-10px;text-align-last:right;align-self: flex-end">
                                            <v-icon  color="red" icon dark  class="" @click="drinkMeasureitem.splice(index, 1)">mdi-close-circle</v-icon>
                                        </v-col>
                                    </v-row>
                                <v-col cols="12" style="text-align-last:right">
                                    <span @click="add" style="color:#FE5800" class="">{{$t('zz_add_new')}}<v-icon class="pr-0 addnewicon">mdi-plus-circle-outline</v-icon></span>
                                </v-col>
                                </v-card>


    <!-- DRINK TYPE / SECTION      -->
                                <v-divider></v-divider>
                            </v-container>
                            <!-- <strong >Category</strong>
                                        <v-row>
                                            <v-col v-for="(category,index) in categories" :key="index" cols="4" md="4" sm="4">
                                                <v-btn block tile
                                                :outlined="category.selected?false:true"
                                                color="primary"
                                                class="text-left"
                                                style="font-size:10px"
                                                height="70"
                                                @click="category.selected=!category.selected" >
                                                    <v-avatar tile height="24" width="24" left  >
                                                    <v-img  :src="unit.image" class="mr-5"></v-img>
                                                    <p v-html="category.name"></p>
                                                    </v-avatar>
                                                    <div style="font-size:9px;text-align:center;" class="d-flex" justify="center">
                                                    <span class="ml-auto mr-auto">
                                                    <img  :src="category.image" class="" width="36" style="margin-bottom:8px"/><br>
                                                    <p v-html="category.name"></p></span>
                                                </div>
                                                    <input type="checkbox" :name="'categories['+index+']'" v-model="category.selected"  :value="category.id" class="d-none"/>
                                                </v-btn>
                                            </v-col>
                                        </v-row> -->


                            <v-row class="px-3 pt-5">
                                <v-col cols="6" cols-sm="12">
                                        <div class="section-label pb-0 ma-0">{{$t('zz_drink_type')}}</div>
                                        <div class="english-label-black pa-0 ma-0">ED5 DRINK SECTION</div>
                                </v-col>

                            </v-row>
                            <v-card elevation="24" class="edit-drink-card pa-3 my-3">
                                <v-row>
                                    <v-col cols="6" >
                                        <v-text-field
                                        v-model="dtype"
                                        name="dtype"
                                        :label="$t('zz_add_drink_type')">
                                        </v-text-field>

                                    </v-col>
                                    <v-col cols="6">
                                        <v-btn color="primary" tile style="align-self: center;" class="font-weight-bold" @click="addtype">{{$t('zz_add')}}</v-btn>

                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col v-for="(type,index) in types" :key="index">
                                        <v-btn
                                            :outlined="type.selected?false:true"
                                            height="30"
                                            color="primary"
                                            class="text-left"
                                            @click="type.selected=!type.selected"
                                            style="font-size:10px">
                                            <div style="font-size:12px;text-align:center;" class="d-flex" justify="center">
                                                <span class="mx-auto">
                                                <!-- <img  :src="type.image" class="" height="36" style="margin-bottom:8px"/><br> -->
                                                <p v-html="type.name"></p></span>
                                            </div>
                                            <input type="checkbox" :name="'types['+index+']'" v-model="type.selected"  :value="type.id" class="d-none"/>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
<!-- ALLERGENS      -->
                            <v-container v-if="!separator" class="">
                                <v-divider></v-divider>
                                <v-row class="px-3 pt-5 spaced-apart">
                                    <v-col cols="6">
                                        <div class="section-label pb-0 ma-0">{{$t('zz_allergens')}}</div>
                                        <div class="english-label-black pa-0 ma-0">ED6 ALLERGENS  </div>
                                    </v-col>

                                </v-row>
                                <v-card elevation="24" class="edit-drink-card pa-3 my-3">
                                    <v-row class="text-center">
                                        <v-col v-for="(allergen,index) in allergens" :key="index">
                                            <v-btn
                                            :outlined="allergen.selected?false:true"
                                            color="primary"
                                            height="90"
                                            class="ma-0"
                                            @click="allergen.selected=!allergen.selected"
                                            style="font-size:10px"
                                            :name="allergen.name">
                                                <div style="font-size:9px;" class="d-flex text-center" justify="center">
                                                    <span class="ml-auto mr-auto">
                                                    <img  :src="allergen.image" class="" width="36" style="margin-bottom:8px"/><br>
                                                    <p class="d-inline-block text-truncate"
                                                    v-html="allergen.name"></p></span>
                                                </div>
                                                <input
                                                type="checkbox"
                                                :name="'allergens['+index+']'"
                                                v-model="allergen.selected"
                                                :value="allergen.id" class="d-none"/>
                                            </v-btn>
                                        </v-col>
                                        <v-col v-for="(allergen,index) in allergens" :key="index">
                                            <!-- <v-btn
                                            :outlined="allergen.selected?false:true"
                                            color="primary"
                                            height="90"
                                            class="ma-0"
                                            @click="allergen.selected=!allergen.selected"
                                            style="font-size:10px"
                                            :name="allergen.name">
                                                <div style="font-size:9px;" class="d-flex text-center" justify="center">
                                                    <span class="ml-auto mr-auto">
                                                    <img  :src="allergen.image" class="" width="36" style="margin-bottom:8px"/><br>
                                                    <p class="d-inline-block text-truncate"
                                                    v-html="allergen.name"></p></span>
                                                </div>
                                                <input
                                                type="checkbox"
                                                :name="'allergens['+index+']'"
                                                v-model="allergen.selected"
                                                :value="allergen.id" class="d-none"/>
                                            </v-btn> -->
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-container>
                            <v-container class="">

<!-- TRANSLATIONS                                  -->

                                <div class="section-label pb-0 ma-0">{{$t('zz_translations')}}</div>
                                <div class="english-label-black pa-0 ma-0">ED7 TRANSLATIONS  </div>
                                <v-card elevation="24" v-for="(tlang,ind) in translationlanguages" :key="'itmtransname-'+tlang" class="center-aligned-content-item my-3 mb-6">
                                    <v-col cols="12" >
                                                    <img :src="'https://api.juzzap.com/storage/flags/'+tlang+'.svg'" height="20px">
                                                    <span class="lang-short-code"> - {{tlang}}</span>
                                                    <v-text-field
                                                        outlined
                                                        v-model="languagetranslations[tlang].title"
                                                        name="tname[tlang]"
                                                        :label="$t('zz_title')"

                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" >

                                                    <v-text-field
                                                        outlined
                                                        v-model="languagetranslations[tlang].subtitle"
                                                        name="tsubname[tlang]"
                                                        :label="$t('zz_sub_title')"

                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" class="">

                                                    <v-text-field
                                                        outlined
                                                        v-model="languagetranslations[tlang].brand"
                                                        name="tbrand[tlang]"
                                                        :label="$t('zz_brand')"

                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" >

                                                    <editor
                                                    api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                                    initialValue=""
                                                    v-model="languagetranslations[tlang].description"
                                                    :init="editorConfigDescription"
                                                    ></editor>
                                                </v-col>


                                </v-card>
                            </v-container>
                        </v-container>
                </v-container>






                <!-- </v-form> -->
            <!-- </v-container> -->
        <!-- </v-container> -->
        <v-footer padless fixed class="footer-1">
                <v-row class="py-2 pl-5">
                    <v-btn class="d-none d-md-flex px-3 px-2 ma-1 footer-buttons" color="#FE5800" elevation="21" large  @click="submit">{{$t('zz_update')}}</v-btn>
                    <v-btn class="d-md-none d-lg-none d-xl-none px-3 ma-1 footer-buttons" color="#FE5800" elevation="21" small  @click="submit">{{$t('zz_update')}}</v-btn>

                    <v-btn class="d-none d-md-flex px-3 px-2 ma-1" outlined color="#FE5800" elevation="21" large  @click="$router.push({name:'businessfoodlist'});">{{$t('zz_exit')}}</v-btn>
                            <v-btn class="d-md-none d-lg-none d-xl-none px-3 ma-1" outlined color="#FE5800" elevation="21" small  @click="$router.push({name:'businessfoodlist'});">{{$t('zz_exit')}}</v-btn>

                    <!-- <v-btn color="blue darken-1" text @click="backtobusiness()">Close</v-btn>
                    <v-btn color="blue darken-1" text @click="updatedescription()">Save</v-btn> -->
                </v-row>
            </v-footer>

        </v-form>
        </v-container>
    <!-- </v-app> -->
</template>


<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import Editor from '@tinymce/tinymce-vue'

import { Cropper } from 'vue-advanced-cropper'

Vue.use(VeeValidate);
export default {
    props: {
    source: String
  },
  data: () =>
  ({
    dtype:'',
    lcode:"",
    lphoto:"",
    descriptiondialog:false,
    businessdescriptiondata:[],
    businessdescriptionlanguagecode:"",
    businessdescriptionlanguagecodearr:[],
    businessdescriptiontranslatorarr:[],
    desccriptiontype:"",
    businessdescriptiontranslator:"",
    languagelist:[{name:"English",value:"en"},
                    {name:"Spanish",value:"es"},
                    {name:"French",value:"fr"},
                    {name:"German",value:"de"},
                    {name:"Russian",value:"ru"},],
    beverageshow:false,
    beveragemodel:[0,1],
    tastingnotes:'',
    linkhref:'',

    beverageentry:0,
    imageurl:'',
    typestype:'',
    recommendations:'',
    winery:'',
    region:'',
    alcoholvol:0,
    capacity:0,
    imagesrc:'',
    webid:'',
    linkhref:'',
    pairingsuggestions:'',
    modelproductname:'',
    beverages:[],
    isLoading:false,
    search:null,

    mainimguploading:false,
    addphoto: require("@/assets/addphoto.svg"),
    addphoto: require("@/assets/image-plus.svg"),
        pwatop1:require('@/assets/pwa_food_top1.png'),
        pwatop2:require('@/assets/pwa_food_top2.png'),
        pwatop3:require('@/assets/pwa_food_top3.png'),
        pwabottom:require('@/assets/pwa_food_bottom.png'),
      iphone:require('@/assets/iphone3.svg'),
        ph:require('@/assets/port-ph2.jpg'),
        placeholder:require('@/assets/Red-Wine-Holding-Image.png'),

    overlay:false,
    imagepanel:[0],
    panelallergens:[0],
    panelcategory:[0],
    paneltype:[0],
    panelunit:[0],
    paneldrink:[0],
    panelprice:[0],
    panelphoto:[0],
    editorData: '',
    editorConfigDescription: {height: 200,
         menubar: false,
        //  plugins: [
        //    'advlist autolink lists link image charmap print preview anchor',
        //    'searchreplace visualblocks code fullscreen',
        //    'insertdatetime media table paste code wordcount autoresize'
        //  ],
         toolbar:
           ' bold italic | alignleft aligncenter alignright alignjustify'
    },
    subname:'',
    name:'',
    juzzapLogo: require("@/assets/logo-Copy.png"),
    logo: require("@/assets/drink.png"),
    department_id:0,
    departments: [],
    btnColor:"",
    drinkMeasure_id:"",
    valid:true,
    data:[],
    counter: 0,
    name:'',
    brand:'',
    description:'',
    showonmenu:true,
    separator:false,

    drinkMeasureitem:[{'id':'','drinkmeasure':'','price':'','qty':'','unit_id':'','uname':''}],

    itemdescription:[{'id':'','languagecode':'','description':'','business_id':'','drinkitem_id':''}],

    drinkMeasures:[],
    units:[],
    types:[],

    categories:[],

    allergens:[],

    business_id:0,
    uploadedimage:null,
    image:null,
    coordinates:
    {
        width: 0,
        height: 0,
        left: 0,
        top: 0
    },
    business:"",
    id:0,
    files: [],
    descriptionLimit: 60,
    entries: [],
    count:0,
    lang:[],
    translationlanguages:[],
    languagetranslations:[],
  }),
  components:
    {
        'editor': Editor,

		Cropper
    },
  created()
    {

        // console.log("business id "+this.$route.params.id);
        // if(this.$route.params.business_id)
        // {
        //     this.business_id=this.$route.params.business_id;
        // }
        this.storeBusiness=JSON.parse(localStorage.getItem('business'));

        this.business_id=this.storeBusiness.id;

        if(this.$route.params.id)
        {
            this.id=this.$route.params.id;
        }

        this.$http
        .get(this.$apidomain+"businessdata/"+this.business_id)
        .then(res => {
        if(res.data.success==0)
                {
                    this.$router.push({name:'businesslistnew'});
                }
                this.business = res.data.businesses;
                this.translationlanguages=res.data.businesses.translationlanguages;

                this.lcode=res.data.businesses.lcode;

                this.lphoto=res.data.businesses.lphoto;

        })
        .catch(err => {
                console.log(err.response);
        });

        this.fetchdata();
        this.fetchCourse();
        this.unitlist();
        this.fetchCategory();
        this.fetchTypes();
        this.fetchAllergens();
        this.fetchDepartments();
        this.fetchbusinessdescription();
        this.fetchLang();


    },
    watch:
    {

        search (val) {
        var th=this;

        // Items have already been loaded
        //if (th.entries.length > 0) return

        // Items have already been requested
        if (th.isLoading) return

        th.isLoading = true



        // Lazily load input items
         this.$http
            .get(this.$apidomain+"beveragelist/"+val)
          .then(res => {
              console.log(res.data);
              const{count,beverages}=res.data
            th.count = count
            th.entries = beverages
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (th.isLoading = false))
      },
    },
  methods:
  {
        addtype()
        {
            this.overlay=true;

            this.$http
            .post(this.$apidomain+"addtype/"+ this.business_id,{ dtype: this.dtype })
            .then(res => {
                if(res.data.success==1)
                    {

                        // this.$router.go('/');
                        this.fetchTypes();
                        this.dtype="";
                        this.overlay=false;


                    }
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });
        },
        isNumber: function(evt)
        {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        setUnitName(uid)
        {
            let th=this;
            let uaddid;
            uaddid=th.drinkMeasureitem[uid].unit_id;
            // alert(uaddid);

            this.units.forEach(function(item,index){
                if(item.id==uaddid)
                {
                    th.drinkMeasureitem[uid].uname=item.name;
                    // alert('uid'+item.name);
                    // return item.name;
                }

            })
            return "";
        },
        fetchMeasureName(mid)
        {
            let th=this;
            let maddid;
            maddid=th.drinkMeasureitem[mid].id;
            // alert(maddid);

            this.drinkMeasures.forEach(function(item,index){
                if(item.id==maddid)
                {
                    th.drinkMeasureitem[mid].drinkmeasure=item.name;
                    // alert('mid'+item.name);
                    // return item.name;
                }

            })



            return "";
        },
        fetchLang()
        {
            this.$http
            .get(this.$apidomain+"languageslist")
            .then(res => {
            this.lang = res.data.languages;
            })
            .catch(err => {
            console.log(err.response);
            });
        },

        addtranslator()
        {
        this.itemdescription.push({
            'id':'',
            'languagecode':'',
            'description':'',
            'business_id':'',
            'drinkitem_id':'',
            })
        },
        createdescription()
        {
            let th = this;
            if (this.$validator.validateAll())
            {

                let fd = new FormData(document.getElementById("editbusinessdesccription"));

                fd.append('type','update');

                fd.append('languagecode',th.businessdescriptionlanguagecode);

                fd.append('businessdescription',th.businessdescriptiontranslator);

                this.$http
                .post(this.$apidomain+"createdrinkitemdescription/"+ this.business_id+"/"+this.id, fd)
                .then(res => {
                if(res.data.success)
                {
                    this.descriptiondialog=false;
                    this.fetchdata();
                    this.fetchbusinessdescription();
                }
                else
                {
                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    this.overlay=false;
                    alert(errmsg[0]);
                    this.descriptiondialog=false;


                }
                })
                .catch(err => {
                    console.log(err.response);
                    this.overlay=false;
                });
            }
        },

        updatedescription()
            {
                let th = this;
                if (this.$validator.validateAll())
                {

                    let fd = new FormData(document.getElementById("editbusinessdesccription"));

                    fd.append('type','update');

                    fd.append('itemdescription',JSON.stringify(this.itemdescription));

                    // fd.append('languagecode',th.businessdescriptionlanguagecodearr);

                    // fd.append('businessdescription',th.businessdescriptiontranslatorarr);

                    this.$http
                    .post(this.$apidomain+"updatedrinkitemdescription/"+ this.business_id+"/"+this.id, fd)
                    .then(res => {
                    if(res.data.success)
                    {
                        this.descriptiondialog=false;
                        this.fetchdata();
                        this.fetchbusinessdescription();
                    }
                    else
                    {
                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        this.overlay=false;
                        alert(errmsg[0]);
                        this.descriptiondialog=false;


                    }
                    })
                    .catch(err => {
                        console.log(err.response);
                        this.overlay=false;
                    });
                }
            },

        fetchbusinessdescription()
        {
            // this.overlay=true;
            this.$http
        .get(this.$apidomain+"drinkitemdescriptiondata/" + this.business_id+"/"+this.id)
        .then(res => {
            if(res.data.success==1)
            {
                this.datadescription=res.data.itemdescription;

                this.businessdescriptiondata=res.data.itemdescription;

                this.itemdescription=res.data.itemdescription;



                // this.businessdescriptiondata=res.datadescription.itemdescription;

                // this.businessdescriptionlanguagecode=res.datadescription.itemdescription.languagecode;

                // this.businessdescriptiontranslator=res.datadescription.itemdescription.description;

                // this.overlay=false;


            }
            else
            {

                // this.overlay=false;




            // console.log(res.data.businesses);
            }
        })
        .catch(err => {
            console.log(err.response);
        });
        },

        backtobusiness()
        {
            this.descriptiondialog=false;

        },
        translator()
        {
            this.descriptiondialog=true;
        },
        getdrinkdata()
        {
            this.beverageshow=true;

            this.name=this.modelproductname.productname;
            this.tastingnotes=this.modelproductname.tastingnotes;
            this.linkhref=this.modelproductname.linkhref;

            this.data.name=this.modelproductname.productname;
            this.pairingsuggestions=this.modelproductname.description;
            this.data.image=this.modelproductname.imageurl;
            this.webid=this.modelproductname.webid;
            this.linkhref=this.modelproductname.linkhref;
            this.imagesrc=this.modelproductname.imagesrc;
            this.capacity=this.modelproductname.capacity;
            this.alcoholvol=this.modelproductname.alcoholvol;
            this.region=this.modelproductname.region;
            this.recommendations=this.modelproductname.recommendations;
            this.typestype=this.modelproductname.typestype;
            this.imageurl=this.modelproductname.imageurl;
            this.beverageentry=this.modelproductname.beverageentry;

        },
        delelteImage(index)
        {
            this.$http
            .post(this.$apidomain+"deleteimages/"+ this.id+'/'+index)
            .then(res => {
                this.data.gallery=res.data.gallery;
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        deleltemainImage()
        {
            this.$http
            .post(this.$apidomain+"drinkitemdeletemainimage/"+ this.id)
            .then(res => {
                this.fetchdata();
                //this.business=res.data.business;
                //this.$router.go();
                //console.log("types "+ this.types);
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        fetchdata() {
            this.$http
            .get(this.$apidomain+"drinkitemData/" + this.id)
            .then(res => {
            this.data=res.data.drinkitems;

            this.languagetranslations=res.data.drinkitems.languagetranslations;

            if(this.data.beverageentry)
            {
                this.beverageshow=true;
                this.beverageentry=1;
            }
            else
            {
                this.beverageshow=false;
                this.beverageentry=0;
            }


            this.name=this.data.name;

            this.pairingsuggestions=this.data.pairingsuggestions;
            this.tastingnotes=this.data.tastingnotes;

            this.image=this.data.imageurl;
            this.webid=this.data.webid;
            this.linkhref=this.data.linkhref;
            this.imagesrc=this.data.imagesrc;
            this.capacity=this.data.capacity;
            this.alcoholvol=this.data.alcoholvol;
            this.region=this.data.region;
            this.recommendations=this.data.recommendations;
            this.typestype=this.data.typestype;
            this.imageurl=this.data.imageurl;
            //this.beverageentry=this.data.beverage;



            this.image=this.data.image;
            this.drinkMeasureitem=res.data.drinkmeasure;
            this.business_id=res.data.drinkitems.business_id;
            // console.log(res.data.businesses);

            // this.$http
            // .get(this.$apidomain+"departmentList/"+this.business_id)
            // .then(res => {
            //     this.departments = res.data.departments;
            // })
            // .catch(err => {
            //     console.log(err.response);
            // });

            this.$http
            .get(this.$apidomain+"businessdata/"+this.business_id)
            .then(res => {
                this.business = res.data.businesses;
            })
            .catch(err => {
                console.log(err.response);
            });

            })
            .catch(err => {
            console.log(err.response);
            });
        },
        fetchDepartments()
        {
            // this.$http
            // .get(this.$apidomain+"departmentList/"+this.business_id)
            // .then(res => {
            //     this.departments = res.data.departments;
            // })
            // .catch(err => {
            //     console.log(err.response);
            // });
        },

        onChange({coordinates, canvas})
        {
            this.mainimguploading=false;

			this.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image
			this.image = canvas.toDataURL()
		},
        uploadImage(event)
        {
			// Reference to the DOM input element
			var input = event.target;
			// Ensure that you have a file before attempting to read it
			if (input.files && input.files[0]) {
                    this.mainimguploading=true;

					// create a new FileReader to read this image and convert to base64 format
					var reader = new FileReader();
					// Define a callback function to run, when FileReader finishes its job
					reader.onload = (e) => {
							// Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
							// Read image as base64 and set to imageData
							this.uploadedimage = e.target.result;
					}
					// Start the reader job - read file as a data url (base64 format)
					reader.readAsDataURL(input.files[0]);
			}
		},
        add()
        {
            this.drinkMeasureitem.push({
                'id':'',
                'drinkmeasure':'',
                'price':'',
                'qty':'',
                'unit_id':'',

            })
        },
        fetchAllergens()
        {
            this.$http
            .get(this.$apidomain+"drinkitemallergenslist/"+this.id)
            .then(res => {
                this.allergens = res.data.allergens;
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        fetchCourse()
        {
            this.$http
            .get(this.$apidomain+"drinkmeasureslist")
            .then(res => {
                this.drinkMeasures = res.data.drinkmeasures;
            })
            .catch(err => {
                console.log(err.response);
            });
        },
        fetchCategory()
        {
            this.$http
            .get(this.$apidomain+"drinkitecategorylist/"+this.id)
            .then(res => {
                this.categories = res.data.category;

               // this.selectedmeats = this.meats.map(() => false);

            })
            .catch(err => {
                console.log(err.response);
            });

        },
        fetchTypes()
        {
            this.$http
            .get(this.$apidomain+"drinkitemtypelist/"+this.id)
            .then(res => {
                this.types = res.data.type;

               // this.selectedmeats = this.meats.map(() => false);

            })
            .catch(err => {
                console.log(err.response);
            });
        },
        unitlist()
        {
            this.$http
            .get(this.$apidomain+"drinkitemunitlist/"+this.id)
            .then(res => {
                this.units = res.data.units;



            })
            .catch(err => {
                console.log(err.response);
            });

        },
        dataURLtoFile(dataurl, filename)
        {

            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type:mime});
        },
        submit()
        {
            console.log("submit call");
            let th = this;
            if (this.$validator.validateAll()) {
                let fd = new FormData(document.getElementById("editdrinkitem"));
                fd.append('business_id',this.business_id);

                fd.append('name',this.data.name);

                if(this.data.description=='' || this.data.description=='null' || this.data.description==null)
                {
                    fd.append('description','');

                }
                else
                {
                fd.append('description',this.data.description);
                }

                fd.append('languagetranslations',JSON.stringify(this.languagetranslations));


                fd.append('drinkMeasureitem',JSON.stringify(this.drinkMeasureitem));

                if(this.data.department_id=="" || this.data.department_id==null)
                {
                    fd.append('department_id',"0");
                }
                else
                {
                    fd.append('department_id',this.data.department_id);
                }


                if(this.pairingsuggestions=='')
                {
                    fd.append('pairingsuggestions','');
                }
                else
                {
                    fd.append('pairingsuggestions',this.pairingsuggestions);
                }

                if(this.tastingnotes=='')
                {
                    fd.append('tastingnotes','');
                }
                else
                {
                    fd.append('tastingnotes',this.tastingnotes);
                }

                if(this.capacity=='')
                {
                    fd.append('capacity','');
                }
                else
                {
                    fd.append('capacity',this.capacity);

                }

                if(this.alcoholvol=='')
                {
                    fd.append('alcoholvol','');
                }
                else
                {
                    fd.append('alcoholvol',this.alcoholvol);

                }

                if(this.region=='')
                {
                    fd.append('region','');
                }
                else
                {
                    fd.append('region',this.region);
                }

                if(this.winery=='')
                {
                    fd.append('winery','');
                }
                else
                {
                    fd.append('winery',this.winery);
                }

                if(this.recommendations=='')
                {
                    fd.append('recommendations','');
                }
                else
                {
                    fd.append('recommendations',this.recommendations);
                }

                if(this.typestype=='')
                {
                    fd.append('typestype','');
                }
                else
                {
                    fd.append('typestype',this.typestype);
                }

                if(this.data.showonmenu)
                {
                fd.append('showonmenu',1);
                }
                else
                {
                fd.append('showonmenu',0);

                }

                if(this.separator)
                {
                fd.append('separator',1);
                }
                else
                {
                fd.append('separator',0);

                }



                if(this.uploadedimage!=null){
                fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));
                }

                this.$http
                .post(this.$apidomain+"updatedrinkItem/"+this.id, fd)
                .then(res => {
                    if(res.data.success==1)
                    {


                        //this.$router.push("/businessdrinklist/"+this.business_id);
                        //this.$router.push({name:'businessdrinklist'});
                        this.$router.push({name:'drinkdragdroplist',params:{tag:this.storeBusiness.businesscode,key:''}});


                    }
                    else if(res.data.success==3)
                    {
                        alert('Hey, It looks like you have not selected Measures');
                        this.overlay=false;
                    }
                    else if(res.data.success==4)
                    {
                        alert('Error! Please selecte type fields.');
                        this.overlay=false;
                    }
                    else
                    {
                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        alert(errmsg[0]);
                    }
                })
                .catch(err => {
                    console.log(err.response);
                });
            }
        }
  }
}
</script>
<style scoped>


    .drink-name1
    {
        font-size:14px !important;
        line-height: 12px !important;
        /* padding-left: 12px; */
        font-weight:800;
        color: rgb(236, 17, 17);
        text-transform:uppercase;
    }

    .drink-name2
    {
        font-size:14px !important;
        line-height: 13px !important;
        padding-bottom: 2px;
        /* padding-left: 12px; */
        font-weight:800;
        color: rgb(20, 20, 20);
        text-transform:uppercase;
    }

    .drink-name3
    {
        font-size:16px !important;
        line-height: 16px !important;
        /* padding-left: 12px; */
        font-weight:800;
        color: rgb(17, 174, 236);
        text-transform:uppercase;
}
.drink-name
{
    font-size:12px !important;
    line-height: 11px !important;
    padding-bottom: 2px;
    /* padding-left: 12px; */
    font-weight:800;
    color: rgb(20, 20, 20);
    text-transform:uppercase;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

}

.drink-subname-list{
        /* padding-top: 10px;
        padding-bottom: 2px; */
        color: rgb(60, 60, 60);
        font-size:11px;
		font-weight: 500;
        text-transform:capitalize;
        text-align: justify;
        line-height: 14px;
        padding-left: 0px !important;
        text-transform:uppercase;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;

    }

.drink-strapline-list{
    /* padding-top: 5px; */
    margin-bottom: 10px;
    color: rgb(60, 60, 60);
    font-size:12px;
    font-weight: 300;
    text-transform:capitalize;
    text-align: justify;
    /* font-style: italic; */
    line-height: 12px;
    padding-left: 0px !important;
    width: 100%;
    overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;

}
.drink-description-list-view {
        font-size: 5px !important;
        font-family: "Roboto", sans-serif !important;
        color: rgb(253, 186, 1) !important;
        font-weight: 300 !important;
        line-height:1 !important;
        text-align: justify !important;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;

    }

.drink-description-list-view-ph {
        font-family: "Roboto", sans-serif !important;
        max-block-size: 80% !important;
        color: rgb(48, 48, 48) !important;
        padding-top: 5px !important;
        padding-bottom: 10px !important;
        padding-left: 0px !important;
        padding-right: 12px !important;
        font-size:8px !important;
        font-weight: 300 !important;
        line-height:1 !important;
        text-align: justify !important;
        margin-bottom: 20px !important;
        margin-top: 20px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        /* background-color: pink !important; */



    }

.drink-price-measure-list
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        font-size:10px !important;
        line-height: 13px !important;
        font-weight:300;
        text-align:left;
        color: #949494;
        text-transform:uppercase;
    }

.drink-price-unit-list
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        font-size:7px !important;
        line-height: 1 !important;
        font-weight:400;
        text-align:right;
        color: #949494;
        text-transform:lowercase;
    }

.drink-price-list
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 5px !important;
        font-size:10px !important;
        line-height: 13px !important;
        font-weight:300;
        text-align:right;
        color: #949494;
        text-transform:uppercase;
    }

.drink-price-icon-list{
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        text-align: end;
        font-size: 22px;
        color: rgb(20, 57, 220);


}

.cardborder-listView
    {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        position: relative;
        margin-bottom: 25px !important;

    }

    .drinkmain .drink-card-text-area{
    /* background-color: #f5de0a !important; */
    padding-top: 10px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
}



.cards-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /* justify-content: space-around; */
    justify-content: space-evenly;
    /* align-items: stretch; */
    align-items: flex-start;
    /* align-items: center; */

}
.card-in-cards-container{
    /*flex: 1 1 ;   Stretching: */
     flex: 0 1 300px; /* No stretching: */
    /* margin: 5px; */

}
.edit-card{
    /*flex: 1 1 ;   Stretching: */
     flex: 1 1 300px; /* No stretching: */
    margin: 5px;

}
.card-in-cards-container-stretch{
    flex: 1 1 400px;
}
.max-350{
    max-width: 350px;
}

.course-name{
    font-size: 30px;
    font-weight: bold;

}
.price{
    font-size: 20px;
    font-weight: bold;

}
.price_explainer{
    font-size: 14px;
    font-weight: 400;

}
.pwa-bg{
    background-color: #f3f3f3;
}
.relative{
    position: relative;
}
.spaced-apart{
    justify-content: space-between;
    align-items: center;
}
.heading-abs1{
    position: relative;
    top: -7px;
    color: #fff;
    font-weight: bold;
    background-color: #fe5800;
    padding: 10px;
    inline-size: fit-content;
    z-index: 1;
    line-height: .75;

}
.top-placeholders{
    position: relative;
    top: -7px;
    color: rgb(57, 57, 57);
    font-weight: 400;
    /* background-color: #fe5800; */
    padding: 10px;
    inline-size: fit-content;
    z-index: 1;
    line-height: .75;

}
.heading-abs2{
    position: absolute;
    top: 53px;
    left: 25px;
    color: rgb(91, 91, 91);
    font-weight: bold;
    padding: 10px;
    inline-size: fit-content;
    z-index: 3;
}
.true-center{
    display: grid;
    place-items: center;
}
.price{
    font-size: 16px;
    font-weight: 600;
    color: #fe5800;
}
.price-text{
    font-size: 14px;
    font-weight: 500;
}
.descr{
    font-size: 12px;
    font-weight: 400;
    text-align: justify;
    color: rgb(102, 102, 102);
    line-height: 1;
    }
.full-width{
    width: 100%;
}
.imgaesfade{
    opacity: 0.75;
    filter: blur(.5px);
}
.inactive{

    opacity: 0.25;
    /* text-decoration:line-through; */
}
.hidden-notice2{
  color: #FE5800;
  flex-wrap: wrap;
  font-size: 25px;
  font-weight: 800;

}
.secname{
    font-size: 20px;
    font-weight: 800;
}
.screen{
    /* width: 400px; */
    position: absolute;
    top: 0px;
    z-index: 3;
    /* opacity: 0.5; */
    overflow: show;

}
.screentop{
    margin-top: 50px;
}
.pwacontent{
    position: relative;
    top: 36px;
}

.bottom-right{
    position: absolute;
    bottom: 10px;
    right: 10px;
}
.preview-image-screen{
    position: absolute;
    top: 160px;
}
.preview-cards-container{
    position: absolute;
    top: 160px;
    left: 0px;
    right: 0px;
}
.edit-drink-card{
    /* position: absolute; */
    /* top: 10px; */
    z-index:4;
    flex: 1 1 350px;
    width: 100%;
    justify-content: center;

}
.spacedout{
    justify-content: space-between;
}
.new-drink-tiem-preview-card{
    /* position: absolute; */
    /* top: 10px; */
    z-index:4;
    flex: 1 1 350px;
    width: 90%;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;


}
.edit-drink-card2{
    /* position: absolute; */
    /* top: 300px; */

    margin-top: 15px;
    z-index:4;
    flex: 1 1 350px;
    width: 90%;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    opacity: 0.5;

}
.contain{
    flex-flow: column wrap;
}
.cat-contain{
    flex: 1 1 350px;
    width: 90%;
    margin-left: auto !important;
    margin-right: auto !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    /* flex-flow: column wrap;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    justify-content: space-around; */
}
.cat-buttons{
    flex: 1 1 150px;
    margin: 5px;
    text-align-last: center;


}
.drink-cards-card{
    flex: 1 1 350px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    justify-content: space-around;

}
.preview-eidt-contianer{
    display: grid;
    grid-template-columns: minmax(400px, 30%) 1fr;
    justify-content: space-around;
    /* display: flex; */
    /* flex-wrap: wrap; */
    /* justify-content: center; */
    margin: auto;
}
.separator{
        color: rgb(255, 255, 255);
        background-color: #fe5800;
        font-size:12px;
		line-height: 12px;
        font-weight: 500;
        text-align: left;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        text-transform:capitalize;
        vertical-align: middle;
        border-radius: 0px;
        /* box-shadow: 3px 3px #ff00dd;
        justify-content: center; */

}
.preview-cards-container{
    width: 90%;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
}
.footer-buttons{
    background-color: #FE5800;
    color: white !important;
}
.tanslation-card{
    border: #FE5800;
    border-style: solid;
    /* width: 33em; */
    min-width: 25em;
    margin-top: 25px;
    margin-bottom: 25px;
  }
  .lang-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;


}
.drink-image{
height: 200px !important;
justify-content: center;
}
.image-icon{
    background-color: rgba(255, 255, 255, .75);
    border-radius: 50%;
    padding-left: auto;
    padding-right: auto;

}
.image-icon:hover{
    transform: scale(1.15);
}
.container-restrict{
    max-width: 50vw !important;
}
.justify-centered{
    justify-content: center;
}
.preview-screen{
    max-width: 400px;
    height: 80vh;

}
.split-container{
    display: grid;
    grid-template-columns: minmax(400px, 400px) .75fr;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.centeredimg{
    justify-content: center;
}
.coursehidden{
    position: absolute;
    top: 175px;
    left: 50px;
    right: 50px;
    flex: 1 1 150px;
    text-align: center;
    font-size: 50px;
    line-height: 1;
    font-weight: bold;
    color: #FE5800;
    opacity: .75 !important;
    z-index: 10;

}
.separatorhidden{
    position: absolute;
    top: 175px;
    left: 50px;
    right: 50px;
    flex: 1 1 150px;
    text-align: center;
    font-size: 50px;
    line-height: 1;
    font-weight: bold;
    color: #000000;
    opacity: .75 !important;
    z-index: 10;
}
.english-label-black{
    font-size: 10px;
    color: #414141;
}
.bgpanel{
    background-color: #fafafa;

}
</style>
